import gql from 'graphql-tag'

export const insertContact = ({ contactData, contactOrganizations }) => {
	return {
		mutation: gql`
			mutation insertSingleContact($contact: contacts_insert_input!) {
				insert_contacts_one(object: $contact) {
					id
				}
			}
		`,
		variables: {
			contact: {
				...contactData,
				contacts_organizations: {
					data: contactOrganizations.map(org => ({
						organization_id: org.id,
						active: true
					}))
				}
			}
		}
	}
}
